export function all (state) {
  return state.all
}

export function one (state) {
  return state.one
}

export function pagination (state) {
  return state.pagination
}
